const FULL_ACCESS = '*';

export function normalizeAdminPermissions(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return [FULL_ACCESS];
  const permissions = raw.map((value) => String(value).trim()).filter(Boolean);
  return permissions.length > 0 ? permissions : [FULL_ACCESS];
}

export function canAccessAdminSection(permissions, section) {
  const normalized = normalizeAdminPermissions(permissions);
  return normalized.includes(FULL_ACCESS) || normalized.includes(section);
}

export function getDefaultAdminTab(permissions) {
  if (canAccessAdminSection(permissions, 'products')) return 'products';
  if (canAccessAdminSection(permissions, 'news')) return 'news';
  if (canAccessAdminSection(permissions, 'subscriptions')) return 'subscriptions';
  return 'products';
}
